import {Component, computed, effect, inject} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {ActivatedRoute, Router} from '@angular/router';
import {ElciaButton} from '../../components/buttons/button/button';
import {LocalDropdown} from '../../components/local-dropdown/local-dropdown';
import {NgOptimizedImage} from '@angular/common';
import {TextInput} from '../../components/text-input/text-input';
import {TranslatePipe} from '@ngx-translate/core';
import {MessageModule} from 'primeng/message';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {passwordMatchValidator, passwordStrengthValidator} from '../../utils/form.utils';
import {AuthService, ResetPasswordRequest} from '../../../api';
import {lastValueFrom} from 'rxjs';
import {injectMutation} from '@tanstack/angular-query-experimental';

@Component({
  selector: 'elcia-reset-password',
  imports: [
    ElciaButton,
    LocalDropdown,
    NgOptimizedImage,
    TextInput,
    TranslatePipe,
    MessageModule,
  ],
  templateUrl: './reset-password.html',
  styleUrl: './reset-password.scss',
})
export class ResetPassword {
  authService = inject(AuthService);
  router = inject(Router);
  private readonly queryParams = toSignal(inject(ActivatedRoute).queryParamMap);


  token = computed(() => {
    return this.queryParams()?.get('token');
  });

  email = computed(() => {
    return this.queryParams()?.get('email');
  });

  fg = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required, passwordStrengthValidator()]),
    confirmPassword: new FormControl('', Validators.required),
  }, {validators: passwordMatchValidator()})
  onParamsBound = effect(() => {
    if (this.email() && !this.fg.controls.email.value) {
      this.fg.controls.email.setValue(this.email()!);
    }
  });

  resetPasswordMutation = injectMutation(() => ({
    mutationFn: (request: ResetPasswordRequest) => lastValueFrom(this.authService.resetPassword(request)),
    onSuccess: () => {
      this.router.navigate(['/auth'], {queryParams: {email: this.email()}});
    }
  }));

  async resetPassword() {
    const value = this.fg.getRawValue();
    if (this.token()) {
      const resetPasswordRequest = {
        email: value.email,
        token: this.token()!,
        newPassword: value.password,
      } as ResetPasswordRequest;
      this.resetPasswordMutation.mutate(resetPasswordRequest);
    }
  }
}
